import { render, staticRenderFns } from "./EditTransportFoamModal.vue?vue&type=template&id=ddb28b50&scoped=true&"
import script from "./EditTransportFoamModal.vue?vue&type=script&lang=js&"
export * from "./EditTransportFoamModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTransportFoamModal.vue?vue&type=style&index=0&id=ddb28b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb28b50",
  null
  
)

component.options.__file = "EditTransportFoamModal.vue"
export default component.exports